export default function scrollDirection() {
  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var requestId = null;

  init();

  function init() {
    updateScroll();
    window.addEventListener("resize", onResize);
    document.addEventListener("scroll", onScroll);
  }

  function onScroll() {
    if (!requestId) {
      requestId = requestAnimationFrame(updateScroll);
    }
  }

  function onResize() {
    if (!requestId) {
      requestId = requestAnimationFrame(updateScroll);
    }
  }

  function updateScroll() {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */

    curScroll = w.scrollY || doc.scrollTop;

    if (curScroll > 0) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }

    if(curScroll > window.innerHeight) {
      document.body.classList.add("screen-scrolled");
    } else {
      document.body.classList.remove("screen-scrolled");
    }

    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      if (direction === 2 && curScroll > 0) {
        document.body.classList.add("scroll-down");
        document.body.classList.remove("scroll-up");
        prevDirection = direction;
      } else if (direction === 1) {
        document.body.classList.remove("scroll-down");
        document.body.classList.add("scroll-up");
        prevDirection = direction;
      }
    }

    prevScroll = curScroll;

    requestId = null;
  }
}
